import Vue from 'vue'
import Router from 'vue-router'
import Justbon from '@/views/login/Justbon.vue'
import JCP from '@/views/login/JCP.vue'
import Verify from '@/views/login/Verify.vue'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/'
      , name: 'justbon'
      , component: Justbon
      , props: {name: '一爱城市登录'}
    },
    {
      path: '/jcp'
      , name: 'jcp'
      , component: JCP
      , props: {name: '其他登录'}
    },
    {
      path: '/verify'
      , name: 'Verify'
      , component: Verify
      , props: {name: '账号验证'}
    }

  ]
})
